import { useRouter } from 'vue-router'
import api from '@/services/api' 

export function useAuth() {
  const router = useRouter()

  async function logout() {
    try {
      const storedUser = localStorage.getItem('user')
      const user = storedUser ? JSON.parse(storedUser) : null

      if (user?.id) {
        await api.post('Logout.php', { user_id: user.id })
      }
    } catch (err) {
      console.warn('Logout failed:', err)
    } finally {
      localStorage.removeItem('user')
      router.push('/')
    }
  }

  return { logout }
}